import { useQuery } from '@tanstack/react-query'
import { adminApi } from '@/lib/api'
import type { PageComponent } from '@/types/admin'

/**
 * Fetches all active page components for use in the admin block editor.
 * No locking logic — all components are available to the platform admin.
 */
export function useAdminCatalog() {
  return useQuery<PageComponent[]>({
    queryKey: ['admin', 'catalog-components'],
    queryFn: () => adminApi.getComponents({ active: true }),
    staleTime: 60_000,
  })
}
